module.exports = __webpack_public_path__ + "static/media/teacher26.8a09496c.png";